import { Api } from '@monorepo/shared/apiClient';
import {
  invalidateLogEntryCache,
  LogEntryCacheEvents,
} from '@monorepo/shared/cacheRegisters/data2/logEntryCacheRegister';
import { DeleteLogEntriesBulkResponse } from 'mapistry-shared';
import { MutationConfig, useMutation } from 'react-query';

type UseLogEntriesBulkDeleteParams = {
  config?: MutationConfig<DeleteLogEntriesBulkResponse, Api.ErrorResponse>;
};

export const useLogEntriesBulkDelete = (
  params?: UseLogEntriesBulkDeleteParams,
) =>
  useMutation(Api.deleteLogEntriesBulk, {
    ...params?.config,
    onSuccess: (data, { logId, organizationId, projectId }) => {
      invalidateLogEntryCache(LogEntryCacheEvents.DELETE, {
        logId,
        organizationId,
        projectId,
      });
    },
  });
